const rootKey = '/account';

export const accountByIdPath = (accountId: string) => {
  return `${rootKey}/${accountId}`;
};
